import L from "leaflet";
import "leaflet/dist/leaflet.css";

// https://github.com/clavijojuan/L.switchBasemap
import "leaflet-switch-basemap";
// import "leaflet-switch-basemap/src/L.switchBasemap.css"; // da un problema al menu

// Leaflet fullscreen https://github.com/brunob/leaflet.fullscreen
// import "leaflet.fullscreen/Control.FullScreen.css";
// import "leaflet.fullscreen";

// https://github.com/Mappy/Leaflet-active-area
import "leaflet-active-area";

import "./item_styles.js";
import "./basemaps.js";
window.L = L;

//
const findBasemapByName = (name) =>
  Basemaps.find((basemap) => basemap.name === name);

const KandinskyMap = (container = "map", options = {}) => {
  const defaultOptions = {
    center: [41.689519, 13.349213],
    zoom: 13,
    zoomControl: false,
    zoomAnimation: true,
    fadeAnimation: true,
    markerZoomAnimation: true,
  };

  const mapOptions = { ...defaultOptions, ...options };
  const LeafletMap = L.map(container, mapOptions);

  L.control.zoom({ position: "topright" }).addTo(LeafletMap);

  const preferredBasemapName = localStorage.getItem("preferredBasemap");
  const preferredBasemap = findBasemapByName(preferredBasemapName);

  const defaultLayer = preferredBasemap || Basemaps[0];

  const basemapsSwitcherArray = Basemaps.map((basemap) => {
    const layer = L.tileLayer(basemap.url, basemap.options);

    if (basemap === defaultLayer) {
      layer.addTo(LeafletMap);
    }

    return { layer, icon: basemap.icon, name: basemap.name };
  });

  new L.basemapsSwitcher(basemapsSwitcherArray, {
    position: "bottomright",
  }).addTo(LeafletMap);

  LeafletMap.on("basemapChange", (eventLayer) => {
    const selectedLayer = Basemaps.find(
      (basemap) => basemap.url === eventLayer.layer._url
    );

    if (selectedLayer) {
      localStorage.setItem("preferredBasemap", selectedLayer.name);
    }
  });

  return LeafletMap;
};

window.KandinskyMap = KandinskyMap;
